<template>
    <v-dialog
        v-model="show"
        :max-width="600"
    >
        <v-card v-if="lastError">
            <v-card-title class="title white--text error" dense>
                <span>{{ $t(lastError.textKey)['title'] }}</span>
                <v-spacer />
                <v-btn icon class="ma-0" @click="show=false">
                    <v-icon color="white">
                        close
                    </v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <v-layout>
                    <v-flex pr-6 shrink>
                        <v-icon color="error">
                            fas fa-exclamation-triangle
                        </v-icon>
                    </v-flex>
                    <v-flex class="text-left" v-html="$t(`${lastError.textKey}.message`, lastError.textParams)" />
                </v-layout>
            </v-card-text>
            <!-- Actions -->
            <v-card-actions>
                <v-spacer />
                <!--Close-->
                <v-btn class="error" @click="show=false">
                    {{ $t('base.close') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    name: 'trimoz-error-dialog',
    data() {
        return {
            show: false,
        };
    },
    computed: {
        ...mapGetters({
            lastError: 'errorHandling/getLastError',
        }),
    },
    watch: {
        lastError: {
            handler(val) {
                if(!this.lastError) {
                    return;
                }
                this.show = true;
            },
            deep: true,
        },
    },
};

</script>

<style scoped>

</style>
